import {Component, inject, OnInit} from "@angular/core";
import {RouterOutlet} from "@angular/router";
import {AuthService, AuthUtilsService} from "./core/auth";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {ToastModule} from "primeng/toast";
import {TenantService} from "./core/tenant/tenant.service";
import { DOCUMENT } from "@angular/common";


@Component({
    selector: 'app-root',

    imports: [
        RouterOutlet,
        ToastModule,
        ConfirmDialogModule,
        // appDisableRightClick,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {

    // This disables right click in application 👇(Commented for now)
    // @HostListener('document:contextmenu', ['$event'])
    // disableRightClick(event: MouseEvent): void {
    //   event.preventDefault();
    // }
    isLoading = false;

    ref: DynamicDialogRef | undefined;

    constructor(
        private readonly authService: AuthService,
        private readonly authUtilsService: AuthUtilsService,
        public dialogService: DialogService,
        private readonly tenantService: TenantService
    ) {
    }

    private _document = inject(DOCUMENT);

    initHead() {
    this._document
      .getElementById("appFavicon")
      ?.setAttribute("href", this.tenantService.getTenantFaviconUrl());
  }

    ngOnInit(): void {

        this.initHead();
        
        // Set primary color
        if (this.tenantService.getTenantPrimaryColorShades()) {
            const root = document.documentElement;
            Object.keys(this.tenantService.getTenantPrimaryColorShades()).forEach(
                (key) => {
                    root.style.setProperty(
                        `--primary-${key}`,
                        this.tenantService.getTenantPrimaryColorShades()[key]
                    );
                }
            );
        }
        // Set secondary color
        if (this.tenantService.getTenantSecondaryColor) {
          const root = document.documentElement;
          root.style.setProperty(
            "--secondary",
            this.tenantService.getTenantSecondaryColor()
          );
        }


        // Default Slate Palette for Secondary Color
        const DEFAULT_SECONDARY_PALETTE = {
            100: '#f1f5f9',
            200: '#e2e8f0',
            300: '#cbd5e1',
            400: '#94a3b8',
            500: '#64748b',
            600: '#475569',
            700: '#334155',
            800: '#1e293b',
            900: '#0f172a',
            950: '#020617',
        };

        if (this.tenantService.getTenantSecondaryColorShades()) {
            const root = document.documentElement;
            Object.keys(this.tenantService.getTenantSecondaryColorShades()).forEach(
                (key) => {
                    root.style.setProperty(
                        `--secondary-${key}`,
                        this.tenantService.getTenantSecondaryColorShades()[key]
                    );
                }
            );
        } else {
            // Fallback to default gray palette
            const root = document.documentElement;
            Object.keys(DEFAULT_SECONDARY_PALETTE).forEach((key) => {
                root.style.setProperty(
                    `--secondary-${key}`,
                    (DEFAULT_SECONDARY_PALETTE as any)[key]
                );
            });
        }

        this.isLoading = true;
        this.authService
            .refreshToken(this.authUtilsService.getRefreshToken())
            .subscribe({
                next: (response) => {

                    this.isLoading = false;
                },
                error: (error) => {
                    this.isLoading = false;
                }
            });
    }
}
